import { GetGradientCSS } from "js/editor/ThemeEditor/components/Gradient";

export function getTextGradientBackground(color, palette) {
    const gradient = color?.gradient ??
        (color?.stops ? color : null) ??
        (color?.type === "gradient" ? color.value : null) ??
        (typeof color === "string" ? palette?.getColor?.(color)?.gradient : null) ??
        palette?.getGradientValue?.(color);

    const resolvedGradient = gradient?.value?.stops ? gradient.value : gradient;

    if (!resolvedGradient?.stops?.length) {
        return null;
    }

    const gradientCSS = GetGradientCSS({
        ...resolvedGradient,
        type: resolvedGradient.type ?? "linear",
        stops: resolvedGradient.stops.map(stop => ({
            ...stop,
            color: palette?.getColor?.(stop.color)?.toRgbString?.() ?? stop.color
        }))
    });

    return gradientCSS ? `${gradientCSS} text` : null;
}

export function getTextColorCss(color, palette) {
    const gradientBackground = getTextGradientBackground(color, palette);

    if (gradientBackground) {
        return `
            background: ${gradientBackground};
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
            -webkit-text-fill-color: transparent;
        `;
    }

    const colorValue = color?.toRgbString?.() ?? color?.value ?? color;
    if (colorValue == null || typeof colorValue === "object") {
        return "";
    }

    return colorValue ? `color: ${colorValue};` : "";
}
